<template>
  <div>
    <v-dialog
        v-if="changeDialog"
        v-model="changeDialog"
        max-width="400px"
        overlay-opacity=.1
        persistent
    >
      <v-card class="neu-glow">
        <v-card-title>
          <vuse-section-definition
              :title=" $t('Global.Profile.changeEmail')"
              icon="mdi-email-sync-outline"
              class="ml-n4 pa-0 pb-4" />
        </v-card-title>
        <v-card-text>
          <v-form ref="changeEmailForm">
            <v-sheet class="neu-glow px-10 py-6">
              <v-row>
                <v-text-field
                    v-model="firstEmail"
                    @input="validate"
                    :label="$t('Global.Profile.enterNewEmail')+'*'"
                    :rules="[ validEmail ]"
                    required
                ></v-text-field>
              </v-row>
              <v-row>
                <v-text-field
                    v-model="secondEmail"
                    @input="validate"
                    :label="$t('Global.Profile.reenterNewEmail')+'*'"
                    :rules="[ validEmail, matchEmail ]"
                    required
                ></v-text-field>
              </v-row>
            </v-sheet>
          </v-form>
        </v-card-text>
        <v-spacer></v-spacer>
        <v-card-actions class="d-flex justify-space-between">
          <v-btn color="blue darken-1" text @click="submitChange" :disabled="!validForm">{{ $t('Global.Profile.save') }}</v-btn>
          <v-btn color="blue darken-1" text @click="cancelDialog">{{ $t('Global.Profile.cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
      <confirm-dialog
          ref="confirmDialog"
          :title="$t('Global.ConfirmDialog.changeDataUserTitle')"
          :message="$t('Global.ConfirmDialog.changeEmailMessage')"
      />
    </v-dialog>
    <v-snackbar
        v-model="snackbar"
        fixed
        right
        :timeout="snackbarTimeout"
        :color="snackbarColor"
        class="mb-8"
    >
      <span>{{ snackbarMessage }}</span>
      <v-icon class="ml-2" dark>{{ snackbarIcon }}</v-icon>
      <template v-slot:action="{ attrs }">
        <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="snackbar = false"
        >
          {{ $t("Global.ConfirmDialog.buttonTextClose") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>

</template>

<script>
import UserInfoApi from "@/mixins/Services/UserInfoApi"
import loader from "@/mixins/Loader"
import ConfirmDialog from "@/components/UI/Dialogs/ConfirmDialog"
import Utils from "@/mixins/Utils";
import snackBar from "@/mixins/snackBarMixin";

export default {
    name: "changeMailDialog",
    components: {
        ConfirmDialog
    },
    mixins: [UserInfoApi, loader, Utils, snackBar],
    props: {
        changeDialog: {
            Type: Boolean,
            default: false
        }
    },
    data() {
        return {
            firstEmail: "",
            secondEmail: "",
            validEmail: v => v.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/) ? true : this.$t('Global.FormRules.invalidFormat'),
            matchEmail: v => v === this.firstEmail ? true : this.$t('Global.FormRules.emailError'),
            validForm: false
        }
    },
    methods: {
        validate() {
            if (this.$refs.changeEmailForm.validate())
                this.validForm = true
            else
                this.validForm = false
        },
        cancelDialog() {
            this.firstEmail = ""
            this.secondEmail = ""
            this.$emit('close-dialog')
        },
        async submitChange(){
            this.confirmDialogTitle = this.$t("Global.ConfirmDialog.changeDataUserTitle")
            const confirm = await this.$refs.confirmDialog.open()
            if (!confirm) return
          try {
            this.setLoader(true)
            await this.changeEmail(this.firstEmail)
            this.setLoader(false)
            await this.launchSnackbar(this.$t("Global.Profile.changeMailOk"),'success','4000','mdi-check-circle')
            this.cancelDialog()
            this.$emit('reload-profile')
          }catch (e) {
            console.error('[CHANGE_MAIL_DIALOG][submitChange] ERROR:', e)
            this.setLoader(false)
            if(this.isErrorText(e)){
              const textError = this.getErrorText(e);
              this.launchSnackbar(this.$t(`Global.Error.c${textError}`), 'error', "2000", 'mdi-alert-octagon')
            }
            this.cancelDialog()
          }
        }
    }
}
</script>

<style>

</style>
